import fedexEulaText from './fedex-eula.txt?raw';

/**
 * Revision of the bundled FedEx EULA text. Must match FEDEX_EULA_VERSION on the
 * backend (FedexRegistrationService) - the BE rejects acceptance of any other
 * version. Bump both on every FedEx EULA revision; customers then re-accept.
 */
// FedEx Form No. 2002382 v 4 June 2024 Rev - December 2024 print (document dated 2024-12-20, sent by the
// FedEx Integrator validation team on 2026-09-18: definition (f) "FedEx" = Federal Express Corporation).
// The footer revision line did not change, so the version carries a print suffix.
export const FEDEX_EULA_VERSION = '2024-06-v4-2024-12';

export const FEDEX_EULA_TEXT = fedexEulaText;

// The authoritative agreement as published by FedEx (Form No. 2002382 v 4 June 2024 Rev,
// 11 pages). FedEx requires the ENTIRE EULA to be displayed in the UI - not behind a link -
// so this is rendered page by page in FedexEulaGate; the .txt above is kept as the
// accessible/selectable fallback when the PDF cannot be rendered.
export { default as FEDEX_EULA_PDF_URL } from './fedex-eula.pdf?url';

// The same agreement as hosted by FedEx - the Integrator validation team asks solutions to
// reference the hosted document; the bundled copy above is rendered (cross-origin pdf.js would
// need CORS) and this link lets the customer open the original.
export const FEDEX_EULA_HOSTED_URL =
  'https://www.fedex.com/content/dam/fedex-com/hdn/FedEx_Standard_End_User_License_Agreement_EULA_for_Hosted_3rd_party_solutions.pdf';
